import { Component } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';
import { CommonService } from '../../../services/common.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmedValidator } from '../../../models/ConfirmedValidator';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, SpinnerComponent, NgxPaginationModule, SearchFilterPipe, RouterOutlet, NgSelectModule],
  templateUrl: './settings.component.html',
  styles: ``
})
export class SettingsComponent {
  //Common Variables
  pageName: string = ''

  user: any;
  ChangePasswordForm = this.formBuilder.group({
    email: [],
    CurrentPassword: ['', [Validators.required]],
    NewPassword: ['', [Validators.required, Validators.minLength(8)]],
    ConfirmPassword: ['', [Validators.required]],
  },
    {
      validator: ConfirmedValidator('NewPassword', 'ConfirmPassword')
    })
  Add_spin: boolean = false;
  Checking: any;
  text_check: boolean = true;
  text_checks: boolean = true;
  text_checkss: boolean = true;
  router: any;
  moduleCategory: any;

  constructor(
    private readonly titleService: Title,
    private readonly toast: HotToastService,
    private readonly commonService: CommonService,
    public formBuilder: FormBuilder,
    private readonly route: ActivatedRoute
  ) {
    this.user = JSON.parse(localStorage.getItem('userData') ?? 'null');
    this.pageName = this.route.snapshot.data['name'];
  }

  ngOnInit(): void {
    this.titleService.setTitle(`QMigrator - ${this.pageName}`);
  }

  get f():any {
    return this.ChangePasswordForm.controls;
  }

  ChangePassword(data: any) {
    let check = {
      email: this.user.email,
      currentPwd: data.CurrentPassword,
      newPwd: data.NewPassword,
    }
    this.Add_spin = true;
    this.commonService.getChangePassword(check).subscribe((data: any) => {
      this.Checking = data;
      this.Add_spin = false;

      if (data === true) {
        this.Add_spin = false;
        this.toast.success("Password Changed Successfully.");
        localStorage.clear();
        sessionStorage.clear();
        this.logout();
      }
      else if (data === false) {
        this.toast.warning("Invalid Current Password.");
      }
    },
      (error) => {
        this.Add_spin = false;
        this.toast.warning('Something Went Wrong!');
      });
  }

  sendEye() {
    this.text_check = !this.text_check;
  }
  sendEyes() {
    this.text_checks = !this.text_checks;
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(["/login"]);
  }
}
